import { HorizontalMenuTabs } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Box, SxProps, Theme, Typography } from '@mui/material';

import { CategoryTab } from '../deepDives.constants';

export type { CategoryTab } from '../deepDives.constants';
export { CATEGORY_TABS } from '../deepDives.constants';

const STRINGS = appStrings.modules.deepDives;

type DeepDivesTabFilterProps = Readonly<{
  count: number;
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
  categories: CategoryTab[];
}>;

export const DeepDivesTabFilter = ({
  count,
  selectedCategory,
  onCategoryChange,
  categories,
}: DeepDivesTabFilterProps) => {
  return (
    <Box sx={containerSx}>
      <Box sx={headerRowSx}>
        <Typography variant="display-xs-semibold" sx={titleSx}>
          {STRINGS.subHeader.title}
        </Typography>
        <Typography
          variant="text-sm-regular"
          color={({ backrs }) => backrs.colors['Colors/Text/text-tertiary']}
        >
          {STRINGS.subHeader.subtitle(count)}
        </Typography>
      </Box>
      <HorizontalMenuTabs
        id="deep-dives-filter-tabs"
        tabs={categories.map((tab) => tab.label)}
        value={categories.findIndex((tab) => tab.value === selectedCategory)}
        setValue={(index) => onCategoryChange(categories[index].value)}
        variant="filter"
      />
    </Box>
  );
};

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  '@container (min-width: 600px)': {
    flexDirection: 'row',
    alignItems: 'center',
  },
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  gap: backrs.spacing['spacing-lg'],
});

const headerRowSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-md'],
});

const titleSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-primary'],
});
